module.exports = __webpack_public_path__ + "vamicons.31e53237.svg";